/**
 * Loading Component
 * Reusable loading spinner with optional message
 */

import styles from './Loading.module.css'

interface LoadingProps {
  message?: string
  size?: 'small' | 'medium' | 'large'
  fullScreen?: boolean
}

export const Loading = ({ 
  message = 'Loading...', 
  size = 'medium',
  fullScreen = false 
}: LoadingProps) => {
  const containerClass = fullScreen 
    ? `${styles.loadingContainer} ${styles.fullScreen}` 
    : styles.loadingContainer

  return (
    <div className={containerClass}>
      <div className={`${styles.spinner} ${styles[size]}`}>
        <div className={styles.spinnerCircle}></div>
        <div className={styles.spinnerCircle}></div>
        <div className={styles.spinnerCircle}></div>
        <div className={styles.spinnerCircle}></div>
      </div>
      {message && <p className={styles.loadingMessage}>{message}</p>}
    </div>
  )
}

export default Loading
